import { render, staticRenderFns } from "./CheckPrescriptionsPage.vue?vue&type=template&id=30171d71&scoped=true&"
import script from "./CheckPrescriptionsPage.vue?vue&type=script&lang=js&"
export * from "./CheckPrescriptionsPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckPrescriptionsPage.vue?vue&type=style&index=0&id=30171d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30171d71",
  null
  
)

export default component.exports